import script from "./accountDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./accountDetail.vue?vue&type=script&setup=true&lang=ts"

import "./accountDetail.vue?vue&type=style&index=0&id=bfa0c198&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfa0c198"]])

export default __exports__